import { HOST } from "../constants/HostConstants";

const sanitizeUser = (user) => {
  if (!user || typeof user !== "object") return null;
  // Validate that user has essential fields (not an empty object)
  if (!user.user_id) return null;
  const { password, ssn, ...rest } = user;
  return rest;
};

export const currentUser = async ({ setUser }) => {
  const cacheKey = "llave_cache_/api/user/userCurrent_{}";

  // Show cached user data immediately if available
  let cachedUser = null;
  try {
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000; // 24 hours
      if (!isExpired) {
        cachedUser = data;
        setUser(cachedUser);
      }
    }
  } catch (e) {
    // Ignore parse errors
  }

  try {
    const res = await fetch(`${HOST}/api/user/userCurrent`, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });

    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch (parseError) {
      if (!cachedUser) {
        setUser(null);
      }
      return;
    }

    if (!res.ok) {
      if (!cachedUser) {
        setUser(null);
      }
      return;
    }

    const sanitized = sanitizeUser(data);
    // Only set user if we have valid user data
    // Otherwise keep existing user state or set to null
    if (sanitized) {
      // Cache the user for 24 hours
      localStorage.setItem(
        cacheKey,
        JSON.stringify({
          data: sanitized,
          timestamp: Date.now(),
        }),
      );
      setUser(sanitized);
    } else if (!data || Object.keys(data || {}).length === 0) {
      // Empty response means user is not authenticated
      if (!cachedUser) {
        setUser(null);
      }
    }
  } catch (error) {
    if (!cachedUser) {
      setUser(null);
    }
  }
};
